import { Flex, Typography } from "antd";
import { StyledButton } from "Components/Button/StyledButton";
import { useUserInfo } from "GlobalStates/User";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { loginWithLinkedin } from "Features/Auth/apis/loginWithLinkedIn";
import { useLoginWithLinkedin } from "Features/Auth/hooks/useLoginWithLinkedin";
import { refreshAccessToken } from "Features/Auth/apis/refreshAccessToken";
import { ROUTES } from "Constants/AllRoutes";

export const LandingPage = () => {
  const { setUser } = useUserInfo();
  const navigate = useNavigate();
  const { state } = useLocation();
  const login = useLoginWithLinkedin();
  const [isComponentReady, setIsComponentReady] = useState(false);
  const [isQueryEnabled, setIsQueryEnabled] = useState(false);

  const { data, isLoading, error } = useQuery({
    queryKey: ["userLogin"],
    queryFn: refreshAccessToken,
    enabled: isQueryEnabled,
  });

  useEffect(() => {
    setIsComponentReady(true);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (isComponentReady) {
        setIsQueryEnabled(Boolean(!state?.justLoggedOut));
      }
    }, 3000);
  }, [isComponentReady, state]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      setUser({
        token: data?.data?.accessToken,
        name: data?.data?.name,
        role: data?.data?.role,
        hasCompletedProfile: data?.data?.hasCompletedProfile,
        isVerified: data?.data?.isVerified,
        picture: data?.data?.picture,
      });
      if (data?.data?.hasCompletedProfile) {
        navigate(ROUTES.MY_CALENDAR);
      } else {
        navigate(ROUTES.REGISTER_ROLE);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, error]);

  return (
    <Flex
      vertical
      gap={"1rem"}
      style={{ height: "100vh" }}
      justify="center"
      align="center"
    >
      <StyledButton onClick={() => login()}>Login With Linkedin</StyledButton>
    </Flex>
  );
};

export const LoginWithLinkedinCallback = () => {
  const hasCallBeenMade = useRef(false);
  const { Title } = Typography;
  const { setUser } = useUserInfo();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const loginUser = useMutation({
    mutationFn: loginWithLinkedin,
    onSuccess: (data) => {
      setUser({
        token: data?.data?.accessToken,
        name: data?.data?.name,
        role: data?.data?.role,
        hasCompletedProfile: data?.data?.hasCompletedProfile,
        isVerified: data?.data?.isVerified,
        picture: data?.data?.picture,
      });
      if (data?.data?.hasCompletedProfile) {
        navigate(ROUTES.MY_CALENDAR);
      } else {
        navigate(ROUTES.REGISTER_ROLE);
      }
    },
  });

  useEffect(() => {
    if (hasCallBeenMade.current) {
      return;
    }
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const params = JSON.parse(atob(state));
    if (code) {
      // make api call to backend using code
      loginUser.mutate({ code, role: params.role });
      hasCallBeenMade.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex vertical align="center" justify="center" style={{ height: "100vh" }}>
      <Title level={3}>Processing your login</Title>
    </Flex>
  );
};
